import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {Headers, Http} from "@angular/http";

@Injectable()
export class PageService {

    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    constructor(
        private http: Http
    ) { }

    //Fetch All Userlist registered
    getPageList(){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/page';
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Fetch single audio information
    getPageInfo(iPageId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/page/'+iPageId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    createPage(pageValue){
        const promise = new Promise((resolve, reject) => {
            let body = "vTitle="+pageValue.vTitle+"&ltDesctiption="+pageValue.tDescription;
            const apiURL = environment.BASE_URL+'/page';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    updatePage(pageValue){
        const promise = new Promise((resolve, reject) => {
            let body = "vTitle="+pageValue.vTitle+"&ltDesctiption="+pageValue.tDescription+"&iPageId="+pageValue.iPageId;
            const apiURL = environment.BASE_URL+'/editpage';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Delete Page
    deletePageCall(iPageId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/deletepage/'+iPageId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/pages/services/page.service.ts